import Section from "../Section";

export default class Footer extends Section {
  constructor(theme, element, pageLoad) {
    super(theme, element, pageLoad);

    this.menuTitleBtns = this.element.querySelectorAll(".footer__mobile-menu-toggle");
    if (this.menuTitleBtns.length > 0) {
      this.menuTitleBtns.forEach(item => {
        item.addEventListener('click', this.toggle); 
      })
    }
  }

  toggle = (e) => {
    const container = e.currentTarget.parentElement.parentElement;
    const expanded = e.currentTarget.getAttribute('aria-expanded');

    container.classList.toggle("footer__mobile-menu-open");
    if (expanded === 'true') {
      e.currentTarget.setAttribute('aria-expanded', 'false');
    } else { 
      e.currentTarget.setAttribute('aria-expanded', 'true');
    }
  }
}
